<template>
  <el-dialog :title="id ? '编辑计划' : '新增计划'" :visible.sync="dialogVisible" width="700px" @close="closeDialog"
    :close-on-click-modal="false" :before-close='goBack' :destroy-on-close="true">
    <el-form class="global-form2" :model="info" ref="info" :rules="rules" label-width="150px">
      <el-form-item label="计划名称" prop="planName">
        <el-input v-model="info.planName" placeholder="请输入计划名称"></el-input>
      </el-form-item>
      <el-form-item label="开启时间" prop="timeRange">
        <el-time-picker is-range v-model="info.timeRange" range-separator="至" start-placeholder="开始时间" format="HH:mm"
          value-format="HH:mm" end-placeholder="结束时间" placeholder="选择时间范围">
        </el-time-picker>
      </el-form-item>
      <el-form-item label="开启频率" prop="frequency">
        <el-cascader v-model="info.frequency" :options="options" :props="{ multiple: true }" clearable></el-cascader>
      </el-form-item>

      <el-form-item label="是否启用" prop="planEnable">
        <el-radio-group v-model="info.planEnable">
          <el-radio label="Y">启用</el-radio>
          <el-radio label="N">禁用</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit" :disabled="submitShow">保存</el-button>
        <el-button @click="goBack">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
const validateTimeRange = (rule, value, callback) => {
  if (!value || value.length !== 2) {
    callback(new Error('请选择开始和结束时间'));
    return;
  }

  const [start, end] = value;
  const startTime = new Date(`1970-01-01T${start}:00`);
  const endTime = new Date(`1970-01-01T${end}:00`);
  const diffMinutes = (endTime - startTime) / (1000 * 60);

  if (diffMinutes < 30) {
    callback(new Error('时间间隔至少30分钟'));
  } else {
    callback();
  }
};

export default {
  name: 'mistforestPlanAdd',
  props: {
    showDialog: {
      type: Boolean
    },
    id: String,
    data: {
      type: Object,
    }
  },

  data() {
    return {
      dialogVisible: false,
      info: {
        projectId: '',
        planName: '',
        planType: 1,
        deviceNumber: '',
        planEnable: '',
        planStatus: '',
        startDate: '',
        endDate: '',
        startTime: '',
        endTime: '',
        keepLength: '',
        intervalDays: '',
        // dateRange: '',
        timeRange: '',
        frequency: []
      },
      planId: '',
      areaList: [],
      submitShow: false,
      options: [
        {
          value: '1',
          label: '周一'
        },
        {
          value: '2',
          label: '周二'
        },
        {
          value: '4',
          label: '周三'
        },
        {
          value: '8',
          label: '周四'
        },
        {
          value: '16',
          label: '周五'
        },
        {
          value: '32',
          label: '周六'
        },
        {
          value: '64',
          label: '周日'
        }
      ],
      rules: {
        planName: [
          { required: true, message: '请输入计划名称', trigger: ['blur', 'change'] },
          { min: 1, max: 8, message: '计划名称长度最多 8 个字符', trigger: ['blur', 'change'] }
        ],
        timeRange: [
          { required: true, message: '请选择计划周期结束时间', trigger: ['blur', 'change'] },
          { validator: validateTimeRange, trigger: ['blur', 'change'] }
        ],
        frequency: [
          { type: 'array', required: true, message: '请至少选择一个开启频率', trigger: ['blur', 'change'] }
        ],
        planEnable: [
          { required: true, message: '请选择是否启用计划', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  watch: {
    showDialog(val) {
      this.dialogVisible = val
      if (val) {
        if (!this.id) { // 新增打开
          this.info.projectId = this.data.projectId
          this.info.deviceNumber = this.data.deviceNumber
        } else {
          this.getPlanDetail(this.id)
        }
      }
    }
  },
  created() {
  },
  methods: {
    // 计算时间差（分钟）
    getTimeDiff(start, end) {
      const startDate = new Date(`2000-01-01T${start}`);
      const endDate = new Date(`2000-01-01T${end}`);
      return (endDate - startDate) / 1000 / 60;
    },
    closeDialog() {
      this.$refs.info.resetFields()
      this.$emit('update:showDialog', false)
    },
    // 清空状态和数值
    change(val) {
      this.$refs.info.resetFields()
      this.info.planType = val
    },

    getPlanDetail(id) {
      this.$axios.get(this.$apis.iot.selectJgSprayPlanByPlanId, {
        planId: id
      }).then((res) => {
        this.info = res
        this.$set(this.info, 'timeRange', [res.startTime, res.endTime])
        const selected = [];
        // 遍历所有选项，按位匹配
        this.options.forEach(option => {
          const value = parseInt(option.value);
          if ((Number(res.intervalDays) & value) === value) {
            selected.push([option.value]);
          }
        });
        this.$set(this.info, 'frequency', selected);
      })
    },

    // 获取计划执行
    getPlanExecute(startime, status) {
      if (status === 'Y') {
        if (startime.getTime() < new Date().getTime()) {
          return 'Y'
        } else {
          return 'N'
        }
      } else {
        return 'N'
      }
    },
    // 保存
    onSubmit() {
      this.info.startTime = this.info.timeRange[0]
      this.info.endTime = this.info.timeRange[1]
      this.info.keepLength = this.getTimeDiff(this.info.timeRange[0], this.info.timeRange[1]).toString()
      this.info.intervalDays = this.info.frequency.reduce((prev, next) => {
        return prev + Number(next)
      }, 0).toString()
      const params = JSON.parse(JSON.stringify(this.info))
      delete params.timeRange;
      delete params.frequency;

      this.$refs.info.validate((valid) => {
        if (valid) {
          let url = this.$apis.iot.insertJgSprayPlan
          if (this.id) {
            url = this.$apis.iot.updateJgSprayPlan
          }
          this.$axios.post(url, params).then(() => {
            if (this.id) {
              this.$message({ message: '修改成功', type: 'success' })
            } else {
              this.$message({ message: '新增成功', type: 'success' })
            }
            this.$emit('planManage')
          })
        }
      })
    },
    // 取消
    goBack() {
      this.$emit('update:showDialog', false)
    }
  }

}
</script>

<style scoped lang="scss">
.tips-box {
  display: flex;
  align-items: center;
  color: #ccc;

  .num {
    color: red;
  }
}

.uform {
  el-form-item {
    height: 20px;
    line-height: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    font-style: normal;
  }

}
</style>
